import React from "react";
import { Box, Flex, Text } from "rebass";
import StyledTag from "../../../../Components/Common/StyledTag";

const TITLE_MAPPER = {
  sad: "ความเศร้า",
  boredom: "ความเบื่อ",
  suicidal_thought: "อยากฆ่าตัวตาย",
};

const TwoQPlus = ({ twoQPlusData }) => {
  return (
    <Flex
      gap={24}
      justifyContent="space-evenly"
    >
      <Flex
        flexDirection="column"
        justifyContent="space-between"
      >
        {/* Titles */}
        {Object.values(TITLE_MAPPER).map((title) => (
          <Text
            key={title}
            textAlign="start"
            color="#507FD0"
            css={{
              fontSize: 18,
              fontWeight: 700,
            }}
          >
            {title}
          </Text>
        ))}
      </Flex>

      <Box
        sx={{
          display: "grid",
          justifyContent: "space-evenly",
          gridRowGap: 24,
          gridColumnGap: 16,
          gridTemplateColumns: "repeat(2, 72px)",
          gridTemplateRows: "repeat(3, auto)",
          alignItems: "center",
        }}
      >
        {Object.keys(TITLE_MAPPER).map((key) => (
          <React.Fragment key={key}>
            {/* Have */}
            <StyledTag
              bgColor="#FBEBEB"
              highlighted={twoQPlusData?.[key]}
              textColor="#EB5764"
              title="มี"
              isDisabled={!twoQPlusData}
            />
            {/* Don't Have */}
            <StyledTag
              bgColor="#EBFBEF"
              highlighted={!twoQPlusData?.[key]}
              textColor="#28B826"
              title="ไม่มี"
              isDisabled={!twoQPlusData}
            />
          </React.Fragment>
        ))}
      </Box>
    </Flex>
  );
};

export default TwoQPlus;
